import { QueryDocumentSnapshot } from "firebase/firestore";
import moment, { Moment } from "moment";
import { SituacaoCalculo } from "./enum";

export default class Calculo implements ICalculo {
  public id!: string;
  public situacao!: SituacaoCalculo;
  public dataCriacao!: Moment;
  public dataInicio!: Moment;
  public dataCalculo!: Moment;
  public dataFim!: Moment;
  public dataProgresso!: Moment;
  public erro?: any;
  constructor(param: ICalculo) {
    Object.assign(this, param);
  }
  public static fromFirestore(snapshot: QueryDocumentSnapshot): Calculo {
    return new Calculo({
      id: snapshot.id,
      dataCriacao: moment(snapshot.get("dataCriacao").toDate()),
      dataInicio: moment(snapshot.get("dataInicio").toDate()),
      situacao: snapshot.get("situacao"),
      dataCalculo: moment(snapshot.get("dataCalculo").toDate()),
      dataFim: moment(snapshot.get("dataFim").toDate()),
      dataProgresso: moment(snapshot.get("dataProgresso").toDate()),
      erro: !!snapshot.get("erro")
        ? JSON.parse(snapshot.get("erro"))
        : undefined,
    });
  }
}

interface ICalculo {
  id: string;
  situacao: SituacaoCalculo;
  dataCriacao: Moment;
  dataInicio: Moment;
  dataCalculo: Moment;
  dataFim: Moment;
  dataProgresso: Moment;
  erro?: any;
}
